// extracted by mini-css-extract-plugin
export default {"Initials":"SupervisorInitials_Initials__wk6Ml","SupervisorInitials":"SupervisorInitials_SupervisorInitials__datPo"};